export const apiFields = () => ({
	isFetching: false,
	lastFetched: 0,
});

export const setIn = (ns, set) => (update) => {
	set((prev) => ({
		[ns]: {
			...prev[ns],
			...(typeof update === "function" ? update(prev[ns]) : update),
		},
	}));
};
